import React from "react";
import { DialogServiceContext } from "./dialog-provider";

export const useDialog = () => React.useContext(DialogServiceContext);
